export const legendSizes = {
    tooltipWidth: 560,
    defaultCellWidth: 130,
    defaultColumnWidth: 80,
    rowHeight: 40,
    legendSummaryHeight: 57,
    columnWidths: {
        entityName: 150,
        totalEarnings: 90,
        mostRecentEarnings: 115,
    },
};

export const squareBulletWidth = 8;
export const bulletKeyHeight = 22;
